import { createAction, props } from '@ngrx/store';
import { Contract, Devis } from '../../models/form-state.model';

export const patchContract = createAction(
  '[Contract] Patch Contract',
  props<{ payload: Partial<Contract> }>()
);

export const init = createAction('[Init]');
